import { Popover } from '@mui/material';
import styled from 'styled-components';

const POPOVER_MIN_WIDTH = '496px';
const POPOVER_MAX_WIDTH = '560px';
// Fixed body height to match the next orders modal of the forecasted stocks analysis
const CONTENT_HEIGHT = '164px';

export const StyledPopover = styled(Popover)`
  & .MuiPaper-root {
    width: max-content;
    min-width: ${POPOVER_MIN_WIDTH};
    max-width: ${POPOVER_MAX_WIDTH};

    margin-top: 8px;

    border-radius: ${({ theme }) => theme.borders.radius.weak};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);

    background: ${({ theme }) => theme.colors.greys.lightest};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px 16px 8px 16px;
`;

export const CloseIcon = styled.img`
  width: 16px;
  height: 16px;

  cursor: pointer;
`;

export const Content = styled.div`
  height: ${CONTENT_HEIGHT};
  overflow: auto;

  padding: 8px 16px 16px 16px;
`;

const buildGridTemplateColumns = (columnCount) => {
  const huggingColumns = Math.max(columnCount - 1, 0);

  return `${'max-content '.repeat(huggingColumns)}1fr`;
};

export const Rows = styled.div`
  display: grid;
  grid-template-columns: ${({ columnCount }) => buildGridTemplateColumns(columnCount)};
`;

export const CenteredContent = styled.div`
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TriggerContainer = styled.div`
  display: flex;
  /* The popover is anchored on this container: it has to hug the button for the right edges of the
  popover and of the trigger to align. */
  width: fit-content;
`;
